import { createPopper } from '@popperjs/core';
function getPopTip() {
    if (!getPopTip.tip) {
        getPopTip.tip = document.createElement('div');
    }
    return getPopTip.tip;
}
function handlerTip(el, binding) {
    let popTip = getPopTip();
    let value;
    if (Object.prototype.toString.call(binding.value) === '[object Function]') {
        value = binding.value();
    } else {
        value = binding.value;
    }
    let { content, placement = 'top', show, maxWidth } = value;

    if (!show) {
        popTip.remove();
        return;
    }

    document.body.append(popTip);
    popTip.style.maxWidth = maxWidth
    popTip.innerHTML = content;
    calcPosition({ el, popTip, placement })
}

function calcPosition({ el, popTip, placement } = {}) {
    const arrowDom = document.createElement('div')
    arrowDom.className = 'pop-tip-arrow';
    arrowDom.setAttribute('data-popper-arrow', '')
    popTip.append(arrowDom)
    createPopper(el, popTip, {
        placement: placement,
        strategy: 'fixed',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 10],
                }
            },
            {
                name: 'arrow',
                options: {
                    element: arrowDom,
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    boundary: 'viewport',
                    padding: 8,
                },
            }
        ],
        onFirstUpdate: (state) => {
            placement = state.placement;
            popTip.className = `pop-tip pop-${placement}`;
        }
    });
}

let tipInsBinding = null

function updateBinding(binding) {
    tipInsBinding = binding
}


export default Vue => {
    Vue.directive('tip', {
        mounted(el, binding) {
            let popTip = getPopTip();
            updateBinding(binding)
            el.addEventListener('mouseover', () => {
                handlerTip(el, tipInsBinding);
            });
            el.addEventListener('mouseout', () => {
                popTip.remove();
            });
            el.addEventListener('click', () => {
                let value;
                if (
                    Object.prototype.toString.call(binding.value) ===
                    '[object Function]'
                ) {
                    value = binding.value();
                } else {
                    value = binding.value;
                }
                let { clickDisappear } = value;
                if (clickDisappear) {
                    popTip.remove();
                }
            });
        },
        updated(el, binding) {
            updateBinding(binding)
        }
    });
};
